import { Component } from '@angular/core';

@Component({
  standalone: true,
  template: '',
})
export class EmptyComponent {}
